import type { RevenueBasis } from '@/api/revenue'
import { Card, EmptyState, type FormatOptions } from '@/design'
import type { GlobalFilters } from '@/lib/filters'

import type { RevenuePeriod } from '../params'
import { CompetitionPanel, ConcentrationPanel, PaymentMethodPanel, type SummaryRead } from './BreakdownPanels'
import { RevenueKpis } from './RevenueKpis'
import { TrendPanel } from './TrendPanel'
import { ChannelWeeklyPanel, CustomerMixPanel } from './WeeklyPanels'

/**
 * The Summary (the proposal's screen 1): the KPI row, the trend, then where the revenue
 * came from — competitions, channels week by week, new against returning, payment
 * methods — and how concentrated it is. Every panel reads under the page's basis.
 */
export function SummaryTab({
  filters,
  basis,
  period,
  summary,
  money,
}: {
  filters: GlobalFilters
  basis: RevenueBasis
  period: RevenuePeriod
  summary: SummaryRead
  money: FormatOptions
}) {
  const data = summary.data?.data
  const { range, days } = period
  return (
    <div className="rv-summary">
      {summary.isError && !data ? (
        <Card>
          <EmptyState variant="outage" compact description="The headline figures could not be loaded." />
        </Card>
      ) : (
        <RevenueKpis summary={data} money={money} busy={summary.isFetching} />
      )}
      <div className="rv-grid">
        <TrendPanel filters={filters} basis={basis} days={days} summary={data} money={money} />
        <CompetitionPanel filters={filters} basis={basis} money={money} />
        <ChannelWeeklyPanel filters={filters} basis={basis} range={range} money={money} />
        <CustomerMixPanel filters={filters} basis={basis} range={range} money={money} />
        <PaymentMethodPanel filters={filters} basis={basis} money={money} siteCredit={data?.siteCreditIncludedUnsplit ?? false} />
        <ConcentrationPanel summary={summary} money={money} />
      </div>
    </div>
  )
}
